// Menu configuration for desktop header
export const menuConfig = [
  {
    id: "banking-expertise",
    label: "menu.bankingExpertise",
    href: "enterprise-banking-services",
    columns: [
      {
        title: "menu.bankingExpertise",
        titleHref: "enterprise-banking-services",
        class: "col-lg-3 col-md-6 header-mob max-wbank",
        links: [
          {
            href: "enterprise-banking-services#RealTimePayments",
            label: "services.banking.realTimePayments"
          },
          {
            href: "enterprise-banking-services#InterbankPayments",
            label: "services.banking.interbankPayments"
          },
          {
            href: "enterprise-banking-services#BankingExpertise",
            label: "services.banking.qrBasedPayments"
          },
          {
            href: "enterprise-banking-services#PaymentRoutingandWorkflows",
            label: "services.banking.paymentRoutingWorkflows"
          },
          {
            href: "enterprise-banking-services#BankingExpertise",
            label: "services.banking.accountingServices"
          },
          {
            href: "enterprise-banking-services#BankingExpertise",
            label: "services.banking.reconciliationServices"
          },
          {
            href: "enterprise-banking-services#CorporateBankingPortal",
            label: "services.banking.corporateBankingPortal"
          },
          {
            href: "enterprise-banking-services#ComplianceandSecurity",
            label: "services.banking.complianceSecurity"
          }
        ]
      },
      {
        title: "menu.enterpriseExpertise",
        titleHref: "enterprise-banking-services#EnterpriseExpertise",
        class: "col-lg-3 col-md-6 header-mob max-wbank",
        links: [
           {
            href: "enterprise-banking-services#DataProcessing",
            label: "services.enterprise.dataProcessing"
          },
          {
            href: "enterprise-banking-services#CRMBusinessSolutions",
            label: "services.enterprise.CRMERPBusinessSolutions"
          },
          {
            href: "enterprise-banking-services#DataEngineering",
            label: "services.enterprise.dataEngineering"
          },
          {
            href: "enterprise-banking-services#BusinessIntelligence",
            label: "services.enterprise.businessIntelligence"
          },
          {
            href: "enterprise-banking-services#EnterpriseArchitectureAssessmentandDevelopment",
            label: "services.enterprise.architectureAssessment"
          },
          {
            href: "enterprise-banking-services#ProcessandWorkflowAutomation",
            label: "services.enterprise.processWorkflowAutomation"
          },
          {
            href: "enterprise-banking-services#CloudMigrationServices",
            label: "services.enterprise.cloudMigrationServices"
          },
          {
            href: "enterprise-banking-services#CentralizedEventMonitoringHub",
            label: "services.enterprise.centralizedEventMonitoring"
          },
          {
            href: "enterprise-banking-services#LegacySystemTransformation",
            label: "services.enterprise.legacyTransformation"
          }
        ]
      },
      {
        title: "menu.digitalServices",
        titleHref: "service-digital",
        class: "col-lg-3 col-md-6 header-mob max-wbank",
        links: [
          {
            href: "service-digital#MobileAppDevelopment",
            label: "services.digital.mobileAppDevelopment"
          },
          {
            href: "service-digital#FrontendDevelopment",
            label: "services.digital.frontendDevelopment"
          },
          {
            href: "service-digital#BackendDevelopment",
            label: "services.digital.backendDevelopment"
          },
          {
            href: "service-digital#APIDevelopment",
            label: "services.digital.apiDevelopment"
          },
          {
            href: "service-digital#CrossPlatformAppDevelopment",
            label: "services.digital.crossPlatformAppDevelopment"
          },
          {
            href: "service-digital#DigitalAssetManagement",
            label: "services.digital.digitalAssetManagement"
          },
          {
            href: "service-digital#OurProducts",
            label: "services.digital.ourProducts.title"
          }
        ]
      },
      {
        title: "menu.aiAutomations",
        titleHref: "ai-automations",
        class: "col-lg-3 col-md-6 header-mob max-wdig",
        links: [
          {
            href: "ai-automations#chatbots",
            label: "services.ai.chatbotsAgents"
          },
          {
            href: "ai-automations#hrautomation",
            label: "services.ai.hrAutomation"
          },
          {
            href: "ai-automations#ocr",
            label: "services.ai.ocrDocumentProcessing"
          },
          {
            href: "ai-automations#workfloworchestration",
            label: "services.ai.workflowOrchestration"
          },
          {
            href: "ai-automations#itsupport",
            label: "services.ai.itSupportAssistant"
          },
          {
            href: "ai-automations#intelligentprocess",
            label: "services.ai.intelligentProcessAutomation"
          },
          {
            href: "ai-automations#itproductionsupport",
            label: "services.ai.itProductionSupport"
          },
          {
            href: "ai-automations#internalknowledge",
            label: "services.ai.internalKnowledgeBase"
          }
        ]
      },
      {
        title: "menu.cloudServices",
        titleHref: "service-cloud",
        class: "col-lg-3 col-md-6 header-mob max-wdig",
        links: [
          {
            href: "service-cloud#cloudmigration",
            label: "services.cloud.cloudMigrationModernization"
          },
          {
            href: "service-cloud#devops",
            label: "services.cloud.devopsAsService"
          },
          {
            href: "service-cloud#paas",
            label: "services.cloud.paas"
          },
          {
            href: "service-cloud#cloudmonitoring",
            label: "services.cloud.cloudMonitoring"
          },
          {
            href: "service-cloud#cloudsecurity",
            label: "services.cloud.cloudSecurity"
          },
          {
            href: "service-cloud#multicloud",
            label: "services.cloud.multiCloud"
          }
        ]
      }
    ]
  },
  {
    id: "enterprise-expertise",
    label: "menu.enterpriseExpertise",
    href: "enterprise-banking-services#EnterpriseExpertise",
    columns: [
      {
        title: "menu.bankingExpertise",
        titleHref: "enterprise-banking-services",
        class: "col-lg-3 col-md-6 header-mob max-wbank",
        links: [
          {
            href: "enterprise-banking-services#RealTimePayments",
            label: "services.banking.realTimePayments"
          },
          {
            href: "enterprise-banking-services#InterbankPayments",
            label: "services.banking.interbankPayments"
          },
          {
            href: "enterprise-banking-services#BankingExpertise",
            label: "services.banking.qrBasedPayments"
          },
          {
            href: "enterprise-banking-services#PaymentRoutingandWorkflows",
            label: "services.banking.paymentRoutingWorkflows"
          },
          {
            href: "enterprise-banking-services#BankingExpertise",
            label: "services.banking.accountingServices"
          },
          {
            href: "enterprise-banking-services#BankingExpertise",
            label: "services.banking.reconciliationServices"
          },
          {
            href: "enterprise-banking-services#CorporateBankingPortal",
            label: "services.banking.corporateBankingPortal"
          },
          {
            href: "enterprise-banking-services#ComplianceandSecurity",
            label: "services.banking.complianceSecurity"
          }
        ]
      },
      {
        title: "menu.enterpriseExpertise",
        titleHref: "enterprise-banking-services#EnterpriseExpertise",
        class: "col-lg-3 col-md-6 header-mob max-wbank",
        links: [
          {
            href: "enterprise-banking-services#DataProcessing",
            label: "services.enterprise.dataProcessing"
          },
          {
            href: "enterprise-banking-services#CRMBusinessSolutions",
            label: "services.enterprise.CRMERPBusinessSolutions"
          },
          {
            href: "enterprise-banking-services#DataEngineering",
            label: "services.enterprise.dataEngineering"
          },
          {
            href: "enterprise-banking-services#BusinessIntelligence",
            label: "services.enterprise.businessIntelligence"
          },
          {
            href: "enterprise-banking-services#EnterpriseArchitectureAssessmentandDevelopment",
            label: "services.enterprise.architectureAssessment"
          },
          {
            href: "enterprise-banking-services#ProcessandWorkflowAutomation",
            label: "services.enterprise.processWorkflowAutomation"
          },
          {
            href: "enterprise-banking-services#CloudMigrationServices",
            label: "services.enterprise.cloudMigrationServices"
          },
          {
            href: "enterprise-banking-services#CentralizedEventMonitoringHub",
            label: "services.enterprise.centralizedEventMonitoring"
          },
          {
            href: "enterprise-banking-services#LegacySystemTransformation",
            label: "services.enterprise.legacyTransformation"
          }
        ]
      },
      {
        title: "menu.digitalServices",
        titleHref: "service-digital",
        class: "col-lg-3 col-md-6 header-mob max-wbank",
        links: [
          {
            href: "service-digital#MobileAppDevelopment",
            label: "services.digital.mobileAppDevelopment"
          },
          {
            href: "service-digital#FrontendDevelopment",
            label: "services.digital.frontendDevelopment"
          },
          {
            href: "service-digital#BackendDevelopment",
            label: "services.digital.backendDevelopment"
          },
          {
            href: "service-digital#APIDevelopment",
            label: "services.digital.apiDevelopment"
          },
          {
            href: "service-digital#CrossPlatformAppDevelopment",
            label: "services.digital.crossPlatformAppDevelopment"
          },
          {
            href: "service-digital#DigitalAssetManagement",
            label: "services.digital.digitalAssetManagement"
          },
          {
            href: "service-digital#OurProducts",
            label: "services.digital.ourProducts.title"
          }
        ]
      },
      {
        title: "menu.aiAutomations",
        titleHref: "ai-automations",
        class: "col-lg-3 col-md-6 header-mob max-wdig",
        links: [
          {
            href: "ai-automations#chatbots",
            label: "services.ai.chatbotsAgents"
          },
          {
            href: "ai-automations#hrautomation",
            label: "services.ai.hrAutomation"
          },
          {
            href: "ai-automations#ocr",
            label: "services.ai.ocrDocumentProcessing"
          },
          {
            href: "ai-automations#workfloworchestration",
            label: "services.ai.workflowOrchestration"
          },
          {
            href: "ai-automations#itsupport",
            label: "services.ai.itSupportAssistant"
          },
          {
            href: "ai-automations#intelligentprocess",
            label: "services.ai.intelligentProcessAutomation"
          },
          {
            href: "ai-automations#itproductionsupport",
            label: "services.ai.itProductionSupport"
          },
          {
            href: "ai-automations#internalknowledge",
            label: "services.ai.internalKnowledgeBase"
          }
        ]
      },
      {
        title: "menu.cloudServices",
        titleHref: "service-cloud",
        class: "col-lg-3 col-md-6 header-mob max-wdig",
        links: [
          {
            href: "service-cloud#cloudmigration",
            label: "services.cloud.cloudMigrationModernization"
          },
          {
            href: "service-cloud#devops",
            label: "services.cloud.devopsAsService"
          },
          {
            href: "service-cloud#paas",
            label: "services.cloud.paas"
          },
          {
            href: "service-cloud#cloudmonitoring",
            label: "services.cloud.cloudMonitoring"
          },
          {
            href: "service-cloud#cloudsecurity",
            label: "services.cloud.cloudSecurity"
          },
          {
            href: "service-cloud#multicloud",
            label: "services.cloud.multiCloud"
          }
        ]
      }
    ]
  },
  {
    id: "digital-services",
    label: "menu.digitalServices",
    href: "service-digital",
    columns: [
      {
        title: "menu.bankingExpertise",
        titleHref: "enterprise-banking-services",
        class: "col-lg-3 col-md-6 header-mob max-wbank",
        links: [
          {
            href: "enterprise-banking-services#RealTimePayments",
            label: "services.banking.realTimePayments"
          },
          {
            href: "enterprise-banking-services#InterbankPayments",
            label: "services.banking.interbankPayments"
          },
          {
            href: "enterprise-banking-services#BankingExpertise",
            label: "services.banking.qrBasedPayments"
          },
          {
            href: "enterprise-banking-services#PaymentRoutingandWorkflows",
            label: "services.banking.paymentRoutingWorkflows"
          },
          {
            href: "enterprise-banking-services#BankingExpertise",
            label: "services.banking.accountingServices"
          },
          {
            href: "enterprise-banking-services#BankingExpertise",
            label: "services.banking.reconciliationServices"
          },
          {
            href: "enterprise-banking-services#CorporateBankingPortal",
            label: "services.banking.corporateBankingPortal"
          },
          {
            href: "enterprise-banking-services#ComplianceandSecurity",
            label: "services.banking.complianceSecurity"
          }
        ]
      },
      {
        title: "menu.enterpriseExpertise",
        titleHref: "enterprise-banking-services#EnterpriseExpertise",
        class: "col-lg-3 col-md-6 header-mob max-wbank",
        links: [
           {
            href: "enterprise-banking-services#DataProcessing",
            label: "services.enterprise.dataProcessing"
          },
          {
            href: "enterprise-banking-services#CRMBusinessSolutions",
            label: "services.enterprise.CRMERPBusinessSolutions"
          },
          {
            href: "enterprise-banking-services#DataEngineering",
            label: "services.enterprise.dataEngineering"
          },
          {
            href: "enterprise-banking-services#BusinessIntelligence",
            label: "services.enterprise.businessIntelligence"
          },
          {
            href: "enterprise-banking-services#EnterpriseArchitectureAssessmentandDevelopment",
            label: "services.enterprise.architectureAssessment"
          },
          {
            href: "enterprise-banking-services#ProcessandWorkflowAutomation",
            label: "services.enterprise.processWorkflowAutomation"
          },
          {
            href: "enterprise-banking-services#CloudMigrationServices",
            label: "services.enterprise.cloudMigrationServices"
          },
          {
            href: "enterprise-banking-services#CentralizedEventMonitoringHub",
            label: "services.enterprise.centralizedEventMonitoring"
          },
          {
            href: "enterprise-banking-services#LegacySystemTransformation",
            label: "services.enterprise.legacyTransformation"
          }
        ]
      },
      {
        title: "menu.digitalServices",
        titleHref: "service-digital",
        class: "col-lg-3 col-md-6 header-mob max-wbank",
        links: [
          {
            href: "service-digital#MobileAppDevelopment",
            label: "services.digital.mobileAppDevelopment"
          },
          {
            href: "service-digital#FrontendDevelopment",
            label: "services.digital.frontendDevelopment"
          },
          {
            href: "service-digital#BackendDevelopment",
            label: "services.digital.backendDevelopment"
          },
          {
            href: "service-digital#APIDevelopment",
            label: "services.digital.apiDevelopment"
          },
          {
            href: "service-digital#CrossPlatformAppDevelopment",
            label: "services.digital.crossPlatformAppDevelopment"
          },
          {
            href: "service-digital#DigitalAssetManagement",
            label: "services.digital.digitalAssetManagement"
          },
          {
            href: "service-digital#OurProducts",
            label: "services.digital.ourProducts.title"
          }
        ]
      },
      {
        title: "menu.aiAutomations",
        titleHref: "ai-automations",
        class: "col-lg-3 col-md-6 header-mob max-wdig",
        links: [
          {
            href: "ai-automations#chatbots",
            label: "services.ai.chatbotsAgents"
          },
          {
            href: "ai-automations#hrautomation",
            label: "services.ai.hrAutomation"
          },
          {
            href: "ai-automations#ocr",
            label: "services.ai.ocrDocumentProcessing"
          },
          {
            href: "ai-automations#workfloworchestration",
            label: "services.ai.workflowOrchestration"
          },
          {
            href: "ai-automations#itsupport",
            label: "services.ai.itSupportAssistant"
          },
          {
            href: "ai-automations#intelligentprocess",
            label: "services.ai.intelligentProcessAutomation"
          },
          {
            href: "ai-automations#itproductionsupport",
            label: "services.ai.itProductionSupport"
          },
          {
            href: "ai-automations#internalknowledge",
            label: "services.ai.internalKnowledgeBase"
          }
        ]
      },
      {
        title: "menu.cloudServices",
        titleHref: "service-cloud",
        class: "col-lg-3 col-md-6 header-mob max-wdig",
        links: [
          {
            href: "service-cloud#cloudmigration",
            label: "services.cloud.cloudMigrationModernization"
          },
          {
            href: "service-cloud#devops",
            label: "services.cloud.devopsAsService"
          },
          {
            href: "service-cloud#paas",
            label: "services.cloud.paas"
          },
          {
            href: "service-cloud#cloudmonitoring",
            label: "services.cloud.cloudMonitoring"
          },
          {
            href: "service-cloud#cloudsecurity",
            label: "services.cloud.cloudSecurity"
          },
          {
            href: "service-cloud#multicloud",
            label: "services.cloud.multiCloud"
          }
        ]
      }
    ]
  },
  {
    id: "ai-automations",
    label: "menu.aiAutomations",
    href: "ai-automations",
    columns: [
      {
        title: "menu.bankingExpertise",
        titleHref: "enterprise-banking-services",
        class: "col-lg-3 col-md-6 header-mob max-wbank",
        links: [
          {
            href: "enterprise-banking-services#RealTimePayments",
            label: "services.banking.realTimePayments"
          },
          {
            href: "enterprise-banking-services#InterbankPayments",
            label: "services.banking.interbankPayments"
          },
          {
            href: "enterprise-banking-services#BankingExpertise",
            label: "services.banking.qrBasedPayments"
          },
          {
            href: "enterprise-banking-services#PaymentRoutingandWorkflows",
            label: "services.banking.paymentRoutingWorkflows"
          },
          {
            href: "enterprise-banking-services#BankingExpertise",
            label: "services.banking.accountingServices"
          },
          {
            href: "enterprise-banking-services#BankingExpertise",
            label: "services.banking.reconciliationServices"
          },
          {
            href: "enterprise-banking-services#CorporateBankingPortal",
            label: "services.banking.corporateBankingPortal"
          },
          {
            href: "enterprise-banking-services#ComplianceandSecurity",
            label: "services.banking.complianceSecurity"
          }
        ]
      },
      {
        title: "menu.enterpriseExpertise",
        titleHref: "enterprise-banking-services#EnterpriseExpertise",
        class: "col-lg-3 col-md-6 header-mob max-wbank",
        links: [
          {
            href: "enterprise-banking-services#DataProcessing",
            label: "services.enterprise.dataProcessing"
          },
          {
            href: "enterprise-banking-services#CRMBusinessSolutions",
            label: "services.enterprise.CRMERPBusinessSolutions"
          },
          {
            href: "enterprise-banking-services#DataEngineering",
            label: "services.enterprise.dataEngineering"
          },
          {
            href: "enterprise-banking-services#BusinessIntelligence",
            label: "services.enterprise.businessIntelligence"
          },
          {
            href: "enterprise-banking-services#EnterpriseArchitectureAssessmentandDevelopment",
            label: "services.enterprise.architectureAssessment"
          },
          {
            href: "enterprise-banking-services#ProcessandWorkflowAutomation",
            label: "services.enterprise.processWorkflowAutomation"
          },
          {
            href: "enterprise-banking-services#CloudMigrationServices",
            label: "services.enterprise.cloudMigrationServices"
          },
          {
            href: "enterprise-banking-services#CentralizedEventMonitoringHub",
            label: "services.enterprise.centralizedEventMonitoring"
          },
          {
            href: "enterprise-banking-services#LegacySystemTransformation",
            label: "services.enterprise.legacyTransformation"
          }
        ]
      },
      {
        title: "menu.digitalServices",
        titleHref: "service-digital",
        class: "col-lg-3 col-md-6 header-mob max-wbank",
        links: [
          {
            href: "service-digital#MobileAppDevelopment",
            label: "services.digital.mobileAppDevelopment"
          },
          {
            href: "service-digital#FrontendDevelopment",
            label: "services.digital.frontendDevelopment"
          },
          {
            href: "service-digital#BackendDevelopment",
            label: "services.digital.backendDevelopment"
          },
          {
            href: "service-digital#APIDevelopment",
            label: "services.digital.apiDevelopment"
          },
          {
            href: "service-digital#CrossPlatformAppDevelopment",
            label: "services.digital.crossPlatformAppDevelopment"
          },
          {
            href: "service-digital#DigitalAssetManagement",
            label: "services.digital.digitalAssetManagement"
          },
          {
            href: "service-digital#OurProducts",
            label: "services.digital.ourProducts.title"
          }
        ]
      },
      {
        title: "menu.aiAutomations",
        titleHref: "ai-automations",
        class: "col-lg-3 col-md-6 header-mob max-wdig",
        links: [
          {
            href: "ai-automations#chatbots",
            label: "services.ai.chatbotsAgents"
          },
          {
            href: "ai-automations#hrautomation",
            label: "services.ai.hrAutomation"
          },
          {
            href: "ai-automations#ocr",
            label: "services.ai.ocrDocumentProcessing"
          },
          {
            href: "ai-automations#workfloworchestration",
            label: "services.ai.workflowOrchestration"
          },
          {
            href: "ai-automations#itsupport",
            label: "services.ai.itSupportAssistant"
          },
          {
            href: "ai-automations#intelligentprocess",
            label: "services.ai.intelligentProcessAutomation"
          },
          {
            href: "ai-automations#itproductionsupport",
            label: "services.ai.itProductionSupport"
          },
          {
            href: "ai-automations#internalknowledge",
            label: "services.ai.internalKnowledgeBase"
          }
        ]
      },
      {
        title: "menu.cloudServices",
        titleHref: "service-cloud",
        class: "col-lg-3 col-md-6 header-mob max-wdig",
        links: [
          {
            href: "service-cloud#cloudmigration",
            label: "services.cloud.cloudMigrationModernization"
          },
          {
            href: "service-cloud#devops",
            label: "services.cloud.devopsAsService"
          },
          {
            href: "service-cloud#paas",
            label: "services.cloud.paas"
          },
          {
            href: "service-cloud#cloudmonitoring",
            label: "services.cloud.cloudMonitoring"
          },
          {
            href: "service-cloud#cloudsecurity",
            label: "services.cloud.cloudSecurity"
          },
          {
            href: "service-cloud#multicloud",
            label: "services.cloud.multiCloud"
          }
        ]
      }
    ]
  },
  {
    id: "cloud-services",
    label: "menu.cloudServices",
    href: "service-cloud",
    columns: [
      {
        title: "menu.bankingExpertise",
        titleHref: "enterprise-banking-services",
        class: "col-lg-3 col-md-6 header-mob max-wbank",
        links: [
          {
            href: "enterprise-banking-services#RealTimePayments",
            label: "services.banking.realTimePayments"
          },
          {
            href: "enterprise-banking-services#InterbankPayments",
            label: "services.banking.interbankPayments"
          },
          {
            href: "enterprise-banking-services#BankingExpertise",
            label: "services.banking.qrBasedPayments"
          },
          {
            href: "enterprise-banking-services#PaymentRoutingandWorkflows",
            label: "services.banking.paymentRoutingWorkflows"
          },
          {
            href: "enterprise-banking-services#BankingExpertise",
            label: "services.banking.accountingServices"
          },
          {
            href: "enterprise-banking-services#BankingExpertise",
            label: "services.banking.reconciliationServices"
          },
          {
            href: "enterprise-banking-services#CorporateBankingPortal",
            label: "services.banking.corporateBankingPortal"
          },
          {
            href: "enterprise-banking-services#ComplianceandSecurity",
            label: "services.banking.complianceSecurity"
          }
        ]
      },
      {
        title: "menu.enterpriseExpertise",
        titleHref: "enterprise-banking-services#EnterpriseExpertise",
        class: "col-lg-3 col-md-6 header-mob max-wbank",
        links: [
          
          {
            href: "enterprise-banking-services#DataProcessing",
            label: "services.enterprise.dataProcessing"
          },
          {
            href: "enterprise-banking-services#CRMBusinessSolutions",
            label: "services.enterprise.CRMERPBusinessSolutions"
          },
          {
            href: "enterprise-banking-services#DataEngineering",
            label: "services.enterprise.dataEngineering"
          },
          {
            href: "enterprise-banking-services#BusinessIntelligence",
            label: "services.enterprise.businessIntelligence"
          },
          {
            href: "enterprise-banking-services#EnterpriseArchitectureAssessmentandDevelopment",
            label: "services.enterprise.architectureAssessment"
          },
          {
            href: "enterprise-banking-services#ProcessandWorkflowAutomation",
            label: "services.enterprise.processWorkflowAutomation"
          },
          {
            href: "enterprise-banking-services#CloudMigrationServices",
            label: "services.enterprise.cloudMigrationServices"
          },
          {
            href: "enterprise-banking-services#CentralizedEventMonitoringHub",
            label: "services.enterprise.centralizedEventMonitoring"
          },
          {
            href: "enterprise-banking-services#LegacySystemTransformation",
            label: "services.enterprise.legacyTransformation"
          }
        ]
      },
      {
        title: "menu.digitalServices",
        titleHref: "service-digital",
        class: "col-lg-3 col-md-6 header-mob max-wbank",
        links: [
          {
            href: "service-digital#MobileAppDevelopment",
            label: "services.digital.mobileAppDevelopment"
          },
          {
            href: "service-digital#FrontendDevelopment",
            label: "services.digital.frontendDevelopment"
          },
          {
            href: "service-digital#BackendDevelopment",
            label: "services.digital.backendDevelopment"
          },
          {
            href: "service-digital#APIDevelopment",
            label: "services.digital.apiDevelopment"
          },
          {
            href: "service-digital#CrossPlatformAppDevelopment",
            label: "services.digital.crossPlatformAppDevelopment"
          },
          {
            href: "service-digital#DigitalAssetManagement",
            label: "services.digital.digitalAssetManagement"
          },
          {
            href: "service-digital#OurProducts",
            label: "services.digital.ourProducts.title"
          }
        ]
      },
      {
        title: "menu.aiAutomations",
        titleHref: "ai-automations",
        class: "col-lg-3 col-md-6 header-mob max-wdig",
        links: [
          {
            href: "ai-automations#chatbots",
            label: "services.ai.chatbotsAgents"
          },
          {
            href: "ai-automations#hrautomation",
            label: "services.ai.hrAutomation"
          },
          {
            href: "ai-automations#ocr",
            label: "services.ai.ocrDocumentProcessing"
          },
          {
            href: "ai-automations#workfloworchestration",
            label: "services.ai.workflowOrchestration"
          },
          {
            href: "ai-automations#itsupport",
            label: "services.ai.itSupportAssistant"
          },
          {
            href: "ai-automations#intelligentprocess",
            label: "services.ai.intelligentProcessAutomation"
          },
          {
            href: "ai-automations#itproductionsupport",
            label: "services.ai.itProductionSupport"
          },
          {
            href: "ai-automations#internalknowledge",
            label: "services.ai.internalKnowledgeBase"
          }
        ]
      },
      {
        title: "menu.cloudServices",
        titleHref: "service-cloud",
        class: "col-lg-3 col-md-6 header-mob max-wdig",
        links: [
          {
            href: "service-cloud#cloudmigration",
            label: "services.cloud.cloudMigrationModernization"
          },
          {
            href: "service-cloud#devops",
            label: "services.cloud.devopsAsService"
          },
          {
            href: "service-cloud#paas",
            label: "services.cloud.paas"
          },
          {
            href: "service-cloud#cloudmonitoring",
            label: "services.cloud.cloudMonitoring"
          },
          {
            href: "service-cloud#cloudsecurity",
            label: "services.cloud.cloudSecurity"
          },
          {
            href: "service-cloud#multicloud",
            label: "services.cloud.multiCloud"
          }
        ]
      }
    ]
  }
];
